var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWaterLevelCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#16badb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-574.22-420.324h36v36h-36Z",
    transform: "translate(574.22 420.324)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.6 9.975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-550.06-390.387h0a8.639,8.639,0,0,1-11.52,0,8.6,8.6,0,0,1-5.76,2.2h-2.88v2.879h2.88a11.455,11.455,0,0,0,5.76-1.54,11.535,11.535,0,0,0,11.52,0,11.464,11.464,0,0,0,5.76,1.54h2.88v-2.88h-2.88A8.609,8.609,0,0,1-550.06-390.387Z",
    transform: "translate(570.22 402.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-544.3-394.947a8.6,8.6,0,0,1-4.681-1.385,8.641,8.641,0,0,1-1.079-.814h0a8.633,8.633,0,0,1-1.513,1.077,8.654,8.654,0,0,1-7.776.367,8.6,8.6,0,0,1-2.231-1.444c-.116.1-.24.2-.361.3a8.6,8.6,0,0,1-5.4,1.9h-2.88v2.88h2.88a11.463,11.463,0,0,0,5.76-1.541,11.535,11.535,0,0,0,11.52,0,11.473,11.473,0,0,0,5.76,1.541h2.88v-2.881Z",
    transform: "translate(570.22 403.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-544.3-401.707a8.6,8.6,0,0,1-4.681-1.385,8.63,8.63,0,0,1-1.079-.815h0a8.633,8.633,0,0,1-1.513,1.077,8.526,8.526,0,0,1-1.1.513,8.644,8.644,0,0,1-6.293,0c-.127-.05-.257-.089-.383-.145a8.609,8.609,0,0,1-2.231-1.444c-.116.1-.24.2-.361.3a8.6,8.6,0,0,1-5.4,1.9h-2.88v2.88h2.88a11.464,11.464,0,0,0,5.76-1.541,11.509,11.509,0,0,0,2.614,1.093,11.525,11.525,0,0,0,6.293,0,11.508,11.508,0,0,0,2.614-1.093,11.473,11.473,0,0,0,5.76,1.541h2.88v-2.881Z",
    transform: "translate(570.22 403.907)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWaterLevelCircle);
export default __webpack_public_path__ + "static/media/icon_water-level--circle.de7e8c5abcb54d25f49ec411f9f4d502.svg";
export { ForwardRef as ReactComponent };